




















































































































import { pvLogApi } from '../pv-log.api';
import BaseTable from '@/modules/core/components/BaseTable';
import { Component } from 'vue-property-decorator';
import { PaginationResult } from '@shared/common/types';
import { PvLog } from '../pv-log';

@Component
export default class PvLogsTable extends BaseTable {
  public sortingPriority = [ {  field: 'date', order: 'desc' } ];
  public pvLogEventTypes = [undefined, 'LOGIN', 'LOGOUT'];
  public async fetchData(): Promise<PaginationResult<PvLog>> {
    return await pvLogApi.findAll({
      ...this.pagination,
      ...this.filters,
      sort: this.sort,
    });
  }

  public clearFilter(
    $event: any,
    filters: Record<string, any>,
    key: string,
  ): void {
    $event.stopPropagation();
    filters[key] = undefined;
  }
}
